<section class="d-flex">
  <div class="container-fluid">
    <div class="row">

      <div class="col-10 col-md-8 col-lg-6 pe-0 d-none d-lg-flex justify-content-start pt-5 mx-auto">
        <div class=" mt-5 pt-5 mx-auto">
          <h1 class="text-center mt-1 fw-bold text-light">Bienvenido</h1>
          <h3 class="text-center mt-1 fw-bold text-light">Sistema de agendamiento de proveedores para la minería</h3>
        </div>

      </div>

      <div class="col-10 col-md-8 col-lg-6 pe-0 mx-auto justify-content-md-end">
        <app-login [loginClass]="'mt-5 pt-5'"></app-login>
      </div>
    </div>
  </div>
</section>
